export default __webpack_public_path__ + "static/media/Rectangle 1029@2x.c52abe74.png";